import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";
import { ASSETS } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role !== "admin") {
        toast.error("Not an admin account");
        return;
      }
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 relative overflow-hidden bg-black">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_30%,rgba(239,43,43,0.15),transparent_55%)]" />

      <div className="w-full max-w-md relative">
        <Link to="/" data-testid="admin-back-home" className="font-mono text-[10px] tracking-[0.3em] text-white/50 hover:text-white transition-colors">
          ← BACK TO SITE
        </Link>

        <div className="mt-6 hairline rounded-2xl bg-white/[0.02] p-10">
          <div className="flex items-center gap-3">
            <img src={ASSETS.logo} alt="DJ SPY" className="h-10" />
            <div className="w-10 h-10 rounded-full bg-red-brand flex items-center justify-center ml-auto">
              <Lock size={18} className="text-white" />
            </div>
          </div>
          <div className="mt-4">
            <div className="font-mono text-[10px] tracking-[0.3em] text-white/50">CONTROL ROOM</div>
            <div className="font-anton text-3xl text-white leading-none mt-2">ADMIN LOGIN</div>
          </div>

          <form className="mt-8 space-y-4" onSubmit={onSubmit} data-testid="admin-login-form">
            <div>
              <label className="font-mono text-[10px] tracking-[0.3em] text-white/50">EMAIL</label>
              <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@djspyofficial.com" />
            </div>
            <div>
              <label className="font-mono text-[10px] tracking-[0.3em] text-white/50">PASSWORD</label>
              <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-primary w-full justify-center">
              {loading ? <Loader2 size={18} className="animate-spin" /> : null}
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
